import LinkIcon from '@atlaskit/icon/core/link';
import { messages } from '@databases/intl/messages';
import { copyState, copyValueLink } from '@databases/selection-menu-actions';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { type SelectionsEffectMenuItemBuilder } from '../types';

export const copyValueLinkMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  _actions,
  skip
) => {
  if (!context.capabilities.canInsertContent) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.COPY_VALUE_LINK,
    content: context.formatMessage(messages['value-actions.copy-link']),
    onClick: () => {
      copyValueLink({
        baseUrl: context.baseUrl,
        contentId: context.contentId,
        databasePath: context.databasePath,
        entryId: context.entryId,
        fieldId: context.fieldId,
      });

      context.closeMenu();
    },
    tooltipDescription: copyState.isCopied
      ? context.formatMessage(messages['copy-link.tooltip'])
      : undefined,
    tooltipPosition: 'right',
    elemBefore: <LinkIcon label="" />,
  });
};
